import { inject } from 'vue';
import type { Integration } from './integrations';
import type { Features } from '~/provides/features.types';

export function useIntegrationEnabled() {
    const FEATURES = inject<Features>('FEATURES');

    function isEnabled(integration: Integration): boolean {
        if (integration.slug === 'mparticle') {
            return false;
        }

        if (integration.slug === 'ftp-pull') {
            return Spark.ftpPullAvailable;
        }

        if (integration.featureFlag) {
            return FEATURES?.[integration.featureFlag] ?? false;
        }

        return true;
    }

    return { isEnabled };
}
